module.exports = __webpack_public_path__ + "img/BA.a1ee5f5d.svg";